export class SideBarSettings{

        title:"";
        link:"";
        
      }